import { Api } from 'core/api';
import { combineReducers } from 'redux';

const settingsApi = new Api({
  initialData: [],
  useEagleApi: true,
  namespace: 'SETTINGS_ITEMS',
  url: '/internal-intranet/settings',
});

export const fetchSettings = () => settingsApi.fetch();

const submitSettingsItemApi = new Api({
  namespace: 'SUBMIT_SETTINGS_ITEMS',
  options: {
    method: 'PUT',
  },
});

export const submitSettingsItem = (id: string, values: any) =>
  submitSettingsItemApi.fetch({
    options: { body: JSON.stringify(values) },
    url: `/settings/${id}`,
  });

export const reducer = combineReducers({
  items: settingsApi.reducer,
});
